import React from 'react';
import { ContainerTexto, Title, TitleContainer, Text, FixedAnchor } from '../styles';
import { Anchor } from 'antd';

const { Link } = Anchor;

const Movimentacoes: React.FC = () => {
  return (
    <>
      <ContainerTexto>
        <TitleContainer id="movimentacoes-inicio">Movimentações</TitleContainer>
        <Text>
          Em ‘Movimentações’ o usuário poderá consultar e exportar suas notas em detalhes. Ele
          poderá ver todas as notas relacionadas à nota principal e acompanhar seu status de
          cobertura.
        </Text>

        <Title id="movimentacoes-info">Informações Principais</Title>
        <Text>
          A tela conta com uma listagem com as informações de número único no Sankhya, número da
          nota, status de cobertura, data de emissão da nota, data de lançamento da nota, inscrição
          estadual e nome do depositante da nota, emitente, pagador da armazenagem, tempo de
          armazenagem contratado, tempo restante de armazenagem, peso bruto e valor da mercadoria da
          nota, de todas as notas das inscrições estaduais selecionadas no cabeçalho, no centro de
          distribuição selecionado.
        </Text>

        <Title id="movimentacoes-notasRelacionadas">Notas Relacionadas</Title>

        <Text>
          Além disso, a expansão da nota conta com mais informações sobre as notas relacionadas à
          principal, sendo elas as informações de tipo de movimentação (entrada ou saída), número
          único no Sankhya, número da nota, data de lançamento, emitente, detalhe do tipo de
          movimentação, peso bruto, valor da mercadoria e chave da nota.
        </Text>

        <Title id="movimentacoes-produtosNota">Produtos da nota</Title>

        <Text>
          O usuário também poderá ver com mais detalhes a situação de cobertura de cada nota,
          clicando no status ele será apresentado com uma linha do tempo contendo a data em que cada
          parte do processo de cobertura aconteceu.
        </Text>
        <Text>
          A tela conta com uma exportação de grade simples em Excel e CSV, onde o usuário poderá
          salvar as informações contidas na tela nesses formatos.
        </Text>

        <Title id="movimentacoes-filtros">Filtros</Title>
        <Text>
          Por fim, a tela também conta com os filtros de produto, número único, número da nota,
          status, pagador da armazenagem, emitente, período de emissão da nota, período de
          lançamento e depositante.
        </Text>
      </ContainerTexto>

      <FixedAnchor>
        <Link title="Início" href='#movimentacoes-inicio' />
        <Link title="Informações Principais" href='#movimentacoes-info' />
        <Link title="Notas Relacionadas" href='#movimentacoes-notasRelacionadas' />
        <Link title="Produtos da Nota" href='#movimentacoes-produtosNota' />
        <Link title="Filtros" href='#movimentacoes-filtros' />
      </FixedAnchor>
    </>

  );
};

export default Movimentacoes;
